import { lazy, Suspense, type ReactElement } from 'react'

import { Loader } from '../components/Loader'

const LazyResetPassword = lazy(() =>
  import('../pages/ResetPassword/ResetPassword').then((module) => ({ default: module.ResetPassword })),
)

export const ResetPasswordRoute = (): ReactElement => {
  return (
    <Suspense fallback={<Loader />}>
      <LazyResetPassword />
    </Suspense>
  )
}
